import React, { useState } from "react";
import { Link, RouterProps, useParams, Redirect } from "react-router-dom";

import {
  Center,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Button,
  FormErrorMessage,
  Alert,
  AlertIcon,
  AlertDescription,
  AlertTitle,
  CloseButton,
  InputGroup,
  InputRightElement,
  IconButton,
  Flex,
  VStack,
  Spinner
} from "@chakra-ui/react";
import { Formik, Form, Field, FieldProps } from "formik";
import * as Yup from "yup";

import { useAuth } from "../../utils/auth-context";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";

type FormValuesProps = {
  password: string;
};

export const Register = (_props: RouterProps) => {
  const [error, setError] = useState<string | null>(null);
  const { token } = useParams<{ token: string }>();
  const { register } = useAuth();
  const [passwordShown, setPasswordShown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const [success, setSuccess] = useState(false);

  return (
    //success ? (
    //   <Center height="100%">
    //     <VStack>
    //       <Alert
    //         status="success"
    //         variant="subtle"
    //         flexDirection="column"
    //         alignItems="center"
    //         justifyContent="center"
    //         textAlign="center"
    //         height="200px"
    //         width="600px"
    //       >
    //         <AlertIcon boxSize="40px" mr={0} />
    //         <AlertTitle mt={4} mb={1} fontSize="lg">
    //           You have successfully created your password and an email has been
    //           sent to you.
    //         </AlertTitle>
    //         <AlertDescription>
    //           Please follow the instructions provided to activate your account.
    //         </AlertDescription>
    //       </Alert>
    //       <Flex>
    //         Please <Link to="/login"> Click here </Link> for login.
    //       </Flex>
    //     </VStack>
    //   </Center>
    // ) : (
    <Center height="100%">
      <Stack
        height="100%"
        spacing="10"
        width="600px"
        justifyContent="center"
        alignItems="center"
      >
        <Heading>Set your account password</Heading>
        {error ? (
          <Alert status="error">
            <AlertIcon />
            <AlertDescription>{error}</AlertDescription>
            <CloseButton
              position="absolute"
              right="8px"
              top="8px"
              onClick={() => setError(null)}
            />
          </Alert>
        ) : null}
        <Formik<FormValuesProps>
          initialValues={{
            password: ""
          }}
          validationSchema={Yup.object({
            // email: Yup.string().email("Enter proper email"),
            password: Yup.string()
              .matches(
                /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
                "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
              )
              .required("This is a required field."),
            confirmPassword: Yup.string()
              .oneOf([Yup.ref("password"), null], "Passwords must match")
              .required("This is a required field.")
          })}
          onSubmit={async (values: any) => {
            setIsLoading(true);
            try {
              if (register) {
                await register({ password: values.password, token: token });
                setIsLoading(false);
              }
            } catch (e) {
              const event = e as any;
              setError(event);
              setIsLoading(false);
            }
          }}
        >
          {() => {
            return (
              <Form style={{ width: "100%" }}>
                <Stack width="100%">
                  {/* <Field name="email">
                    {({ field, form }: FieldProps) => (
                      <FormControl
                        isInvalid={
                          form.errors.email !== undefined &&
                          form.touched.email !== undefined
                        }
                        isRequired
                      >
                        <FormLabel>Email</FormLabel>
                        <Input {...field} id="email" name="email" />
                        <FormErrorMessage>{form.errors.email}</FormErrorMessage>
                      </FormControl>
                    )}
                  </Field> */}
                  <Field name="password">
                    {({ field, form }: FieldProps) => (
                      <FormControl
                        isInvalid={
                          form.errors.password !== undefined &&
                          form.touched.password !== undefined
                        }
                        isRequired
                      >
                        <FormLabel htmlFor="password">Password</FormLabel>
                        <InputGroup>
                          <Input
                            {...field}
                            id="password"
                            type={passwordShown ? "text" : "password"}
                            name="password"
                          />
                          <InputRightElement>
                            <IconButton
                              variant="unstyled"
                              colorScheme="blue"
                              aria-label="Search database"
                              color=" darkGray"
                              icon={
                                passwordShown ? (
                                  <AiOutlineEyeInvisible size={20} />
                                ) : (
                                  <AiOutlineEye size={20} />
                                )
                              }
                              onClick={togglePasswordVisiblity}
                              _focus={{ border: "none" }}
                            />
                          </InputRightElement>
                        </InputGroup>
                        <FormErrorMessage>
                          {form.errors.password}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  <Field name="confirmPassword">
                    {({ field, form }: FieldProps) => (
                      <FormControl
                        isInvalid={
                          form.errors.confirmPassword !== undefined &&
                          form.touched.confirmPassword !== undefined
                        }
                        isRequired
                      >
                        <FormLabel>Confirm Password</FormLabel>
                        <InputGroup>
                          <Input
                            {...field}
                            type={passwordShown ? "text" : "password"}
                            id="confirmPassword"
                            name="confirmPassword"
                          />
                          <InputRightElement>
                            <IconButton
                              variant="unstyled"
                              colorScheme="blue"
                              aria-label="Search database"
                              color=" darkGray"
                              icon={
                                passwordShown ? (
                                  <AiOutlineEyeInvisible size={20} />
                                ) : (
                                  <AiOutlineEye size={20} />
                                )
                              }
                              onClick={togglePasswordVisiblity}
                              _focus={{ border: "none" }}
                            />
                          </InputRightElement>
                        </InputGroup>
                        <FormErrorMessage>
                          {form.errors.confirmPassword}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  <Button
                    type="submit"
                    color="white"
                    bg="#2a9df4"
                    rounded="3"
                    height={"50px"}
                    _hover={{
                      background: "#95c7e3e8"
                    }}
                  >
                    {isLoading ? <Spinner /> : "Save"}
                  </Button>
                </Stack>
              </Form>
            );
          }}
        </Formik>
      </Stack>
    </Center>
  );
};
